function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ui/editorui/boxed/boxededitoruiview
 */
import EditorUIView from '../../editorui/editoruiview';
import LabelView from '../../label/labelview';
/**
 * The boxed editor UI view class. This class represents an editor interface
 * consisting of a toolbar and an editable area, enclosed within a box.
 *
 * @extends module:ui/editorui/editoruiview~EditorUIView
 */

var BoxedEditorUIView = /*#__PURE__*/function (_EditorUIView) {
  _inherits(BoxedEditorUIView, _EditorUIView);

  var _super = _createSuper(BoxedEditorUIView);

  /**
   * Creates an instance of the boxed editor UI view class.
   *
   * @param {module:utils/locale~Locale} locale The locale instance..
   */
  function BoxedEditorUIView(locale) {
    var _this;

    _classCallCheck(this, BoxedEditorUIView);

    _this = _super.call(this, locale);
    /**
     * Collection of the child views located in the top (`.ck-editor__top`)
     * area of the UI.
     *
     * @readonly
     * @member {module:ui/viewcollection~ViewCollection}
     */

    _this.top = _this.createCollection();
    /**
     * Collection of the child views located in the main (`.ck-editor__main`)
     * area of the UI.
     *
     * @readonly
     * @member {module:ui/viewcollection~ViewCollection}
     */

    _this.main = _this.createCollection();
    /**
     * Voice label of the UI.
     *
     * @protected
     * @readonly
     * @member {module:ui/view~View} #_voiceLabelView
     */

    _this._voiceLabelView = _this._createVoiceLabel();

    _this.setTemplate({
      tag: 'div',
      attributes: {
        class: ['ck', 'ck-reset', 'ck-editor', 'ck-rounded-corners'],
        role: 'application',
        dir: locale.uiLanguageDirection,
        lang: locale.uiLanguage,
        'aria-labelledby': _this._voiceLabelView.id
      },
      children: [_this._voiceLabelView, {
        tag: 'div',
        attributes: {
          class: ['ck', 'ck-editor__top', 'ck-reset_all'],
          role: 'presentation'
        },
        children: _this.top
      }, {
        tag: 'div',
        attributes: {
          class: ['ck', 'ck-editor__main'],
          role: 'presentation'
        },
        children: _this.main
      }]
    });

    return _this;
  }
  /**
   * Creates a voice label view instance.
   *
   * @private
   * @returns {module:ui/label/labelview~LabelView}
   */


  _createClass(BoxedEditorUIView, [{
    key: "_createVoiceLabel",
    value: function _createVoiceLabel() {
      var t = this.t;
      var voiceLabel = new LabelView();
      voiceLabel.text = t('Rich Text Editor');
      voiceLabel.extendTemplate({
        attributes: {
          class: 'ck-voice-label'
        }
      });
      return voiceLabel;
    }
  }]);

  return BoxedEditorUIView;
}(EditorUIView);

export { BoxedEditorUIView as default };